import { Pipe, PipeTransform } from '@angular/core';
import { Realisation } from 'src/app/classes/realisation';

@Pipe({
    name: 'realisationForSettlement',
    standalone: false,
})
export class RealisationForSettlementPipe implements PipeTransform {
    transform(realisations: Realisation[], id: number): Realisation | undefined {
        return realisations.find(realisation => realisation.id === id);
    }
}
